import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PostsService } from '../modules/core/services/posts.service';
@Component({
  standalone: false,
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit{

  constructor(
    private router:Router,
    public postsService: PostsService,
  )
  {}

  spremanjeStatus:string='';
  tokenStatus:string='';


  enterEmail ()
  {
    this.router.navigate(['']);
  }


ngOnInit(): void {


 if (this.postsService.spremanjeStatus ==="OK"){
    this.spremanjeStatus = this.postsService.spremanjeStatus;
  }
    else
    {
      this.router.navigate(['']);
  }


  // const statusiTokenPoruke: string[] = [ "EXISTS" , "EXPIRED" , "INVALID" , "ERROR"];
  // const statusiSpremanjaPoruka: string[] = ["ERROR", "OK", "EXISTS" ];

}
}
